import { useSyncPanelsPreferences } from "./use-sync-panels-preferences"
import { useSyncModelPreferences } from "./use-sync-model-preferences"
import { useSyncCorePreferences } from "./use-sync-core-preferences"
import { useSyncTradePreferences } from "./use-sync-trade-preferences"
import { useSyncOptimizationPreferences } from "./use-sync-optimization-preferences"
import { useAppSelector } from "hooks/redux"
import { useDashboardId } from "../context/dashboard-id"
import { selectIsDashboardStoreLoaded } from "../store/selectors/select-is-dashboard-store-loaded"

// Layout-level dashboard preference sync. Per-panel hooks
// (useSyncAssetViewPreferences, useSyncFactorsViewPreferences, useSyncKPIPreferences) must run
// inside their owning panel — they use usePanelId() and scope state per panel — so they are NOT
// aggregated here. Optimization state is dashboard-scoped, so it is.
export function useDashboardPreferencesSync(): boolean {
  const dashboardId = useDashboardId()
  useSyncPanelsPreferences()
  useSyncModelPreferences()
  useSyncCorePreferences()
  useSyncTradePreferences()
  useSyncOptimizationPreferences()

  return useAppSelector((s) => selectIsDashboardStoreLoaded(s, dashboardId))
}
